import { useEffect, useState } from "react";
import { Table } from "@/components/kit/Table/Table";
import { Checkbox, SelectBox, Typography } from "@/components/kit";
import { useStoreOrg } from "../../store/useStoreOrganization";
import useStoreMe from "@/hooks/store/useStoreMe";
import { IUserResponse } from "@/features/admins/types";

interface IProps {
  user: IUserResponse;
  rolesOptions: { title: string; value: string }[];
}

const UserRow = ({ user: userData, rolesOptions }: IProps) => {
  const { me } = useStoreMe();
  const { setState, users } = useStoreOrg();

  const [user, setUser] = useState<IUserResponse & { roleId: string }>();
  console.log("users", users);

  useEffect(() => {
    if (userData && rolesOptions) {
      setUser({
        ...userData,
        roleId:
          userData.id == me?.id
            ? (rolesOptions.find((item) => item.title === "Owner")?.value ?? "")
            : (users.find((item) => item.id === userData.id)?.roleId ?? ""),
      });
    }
  }, [userData, rolesOptions]);

  const handleAdd = (user: IUserResponse & { roleId: string }) => {
    const userIds = users.map((item) => item.id);
    if (userIds.includes(user.id)) {
      const filterUsers = users
        .filter((item) => item.id !== user.id)
        .map((i) => ({ id: i.id, roleId: i.roleId }));
      setState("users", filterUsers);
    } else {
      const newUser = { id: user.id, roleId: user.roleId };
      console.log("new-user", newUser);

      setState("users", [...users, newUser]);
    }
  };

  const handleUpdateRole = (roleId: string, userId: string) => {
    if (user) {
      setUser({ ...user, roleId });
    }
    const update = users.map((item) => {
      if (item.id === userId) {
        return { ...item, roleId };
      } else {
        return { ...item };
      }
    });
    setState("users", update);
  };

  if (user)
    return (
      <Table.RowBody
        key={user.id}
        className="cursor-pointer"
        // onClick={() => {
        //   handleSelectDevice(user);
        // }}
      >
        <Table.Cell name="Name" index={0}>
          <div className="flex gap-x-2 text-gray-400 items-center w-full">
            <div className="border-e flex items-center justify-end pe-2  h-[42px]">
              <Checkbox
                disabled={me?.id === user.id}
                checked={
                  users?.map((item) => item.id)?.includes(user.id) ||
                  user.id === me?.id
                }
                size="md"
                onClick={(e) => e.stopPropagation()}
                onChange={() => handleAdd(user)}
                id="all"
                className=""
              />
            </div>

            <div className="flex  gap-2 items-center">
              <Typography className=" !font-bold " variant="BodyPlus2-Bold">
                {user?.firstName} {user.lastName}
              </Typography>
              {me?.id === user.id && (
                <span className="inline-block rounded-[6px] text-xs p-1 text-gray-800 bg-blue-100">
                  You
                </span>
              )}
            </div>
          </div>
        </Table.Cell>
        <Table.Cell name="Email" index={1}>
          <Typography
            className="truncate"
            color="text-gray-700"
            variant="Caption1-Regular"
            hasTitle
          >
            {user?.email}
          </Typography>
        </Table.Cell>
        <Table.Cell name="Access role" index={2}>
          <div className="h-full w-full flex justify-center items-center">
            <SelectBox
              disabled={me?.id === user.id}
              value={user.roleId}
              placeholder={"Select"}
              options={rolesOptions.filter(
                (item) => !["Employee", "Owner"].includes(item.title),
              )}
              className="!h-[24px] w-full"
              containerClassName=" w-3/4 relative "
              fixedDropdown
              dropdownZIndex={9999}
              renderOption={(item) => (
                <Typography variant="Body1-Regular">{item.title}</Typography>
              )}
              valueKey="value"
              renderValue={(item) => (
                <Typography variant="Body1-Regular">{item.title}</Typography>
              )}
              onChange={(value) => {
                handleUpdateRole(value, user.id);
              }}
            />
          </div>
        </Table.Cell>
      </Table.RowBody>
    );
};

export default UserRow;
